import * as actions from 'actions';

const INITIAL_STATE = {
  answeredChatQuestionsIds: [],
  isSubmitting: false
};

export default (state = INITIAL_STATE, action) => {
  let chatQuestionnaireId = action.chatQuestionnaireId;

  if(!chatQuestionnaireId && action.chatQuestionnaire) {
    chatQuestionnaireId = action.chatQuestionnaire.id;
  }

  if(!chatQuestionnaireId || chatQuestionnaireId !== 'eos') {
    return state;
  }

  switch(action.type) {
    case actions.CHAT_QUESTIONNAIRE_SUBMIT:
      return {
        ...state,
        isSubmitting: true
      };

    case actions.CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS:
    case actions.CHAT_QUESTIONNAIRE_SUBMIT_ERROR:
      return {
        ...state,
        isSubmitting: false
      };

    case actions.CHAT_QUESTION_UPDATE: {
      if(state.answeredChatQuestionsIds.indexOf(action.chatQuestionId) < 0) {
        return {
          ...state,
          answeredChatQuestionsIds: [
            ...state.answeredChatQuestionsIds,
            action.chatQuestionId
          ]
        };
      }

      return state;
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/feedbackSubmission/reducer.js
 **/